module.exports = __webpack_public_path__ + "static/media/combine-img.93fd5c47.png";